"use strict";

import Common from "../Common";
import PalettePanel from "../ui/overlays/PalettePanel";
import MagicBrush from "./MagicBrush";
import ColourBrush from "./ColourBrush";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Brush() {
    // Attributes.
    this._drawLayer = null;
    this._magicBrush = null;
    this._colourBrush = null;
    this._paletteItem = null;
    this._curBrush = null;
    this._audio = null;
}
export default Brush;
//module.exports = Brush;
Brush.prototype.constructor = Brush;


//===================================================
//
// Public
//
//===================================================

Brush.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;

    // Magic brush.
    this._magicBrush = new MagicBrush();
    this._magicBrush.init(drawLayer);

    // Colour brush.
    this._colourBrush = new ColourBrush();
    this._colourBrush.init(drawLayer);

    // Set initial brush.
    this._curBrush = this._colourBrush;
    this._curBrush.colour = Common.assets.getJSON("config").palettePanel.pages[0][0];
    this._paletteItem = this._curBrush.colour;

    // Signals.
    Common.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

Brush.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};


//===================================================
//
// Private
//
//===================================================

Brush.prototype._draw = function (from, to) {
    // TEST: DYN_OUT:
    var dynOutlineContext = Common.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.beginPath();
    dynOutlineContext.strokeStyle = "black";
    dynOutlineContext.lineWidth = this._curBrush.LINE_THICKNESS;
    dynOutlineContext.lineJoin = "round";
    dynOutlineContext.moveTo(from.x, from.y);
    dynOutlineContext.lineTo(to.x, to.y);
    dynOutlineContext.closePath();
    dynOutlineContext.stroke();
};

Brush.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};


//===================================================
//
// Events
//
//===================================================

Brush.prototype.onDrawBegan = function (point) {
    this._curBrush.onDrawBegan(point);
    // TEST: DYN_OUT:
    this._draw(point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
};

Brush.prototype.onDrawMoved = function (from, to) {
    // Sfx.
    if (this._audio == null)
        this._audio = Common.audio.playSound("sfx_tool_paintbrush_wet_use_loop_00", {"loop": true});
    TweenMax.killDelayedCallsTo(this._stopAudio);
    TweenMax.delayedCall(0.25, this._stopAudio, null, this);


    this._curBrush.onDrawMoved(from, to);
    // TEST: DYN_OUT:
    this._draw(from, to);
};

Brush.prototype.onDrawEnded = function () {
    // Sfx.
    TweenMax.killDelayedCallsTo(this._stopAudio);
    if (this._audio != null)
        this._stopAudio();

    // TEST: DYN_OUT:
    Common.game.canvas.drawLayer.dynOutlineData = Common.game.canvas.drawLayer.dynOutlineContext.getImageData(0, 0, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT);
};

Brush.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0) {
        this._curBrush = this._colourBrush;
        this._colourBrush.colour = selection;
    }
    else {
        this._curBrush = this._magicBrush;
        this._magicBrush.textureId = selection;
    }

    this._paletteItem = selection;
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    Brush.prototype,
    "paletteItem",
    {
        get: function () {
            return this._paletteItem;
        }
    });